<template>
  <v-form v-model="valid" @submit.prevent="submit" ref="form">
    <v-card :class="{ ['elevation-12']: $vuetify.breakpoint.smAndUp }">
      <v-card-title class="display-1 pb-1">
        Benachrichtigung versenden
      </v-card-title>
      <v-card-text>
        <p>
          Hier können Sie ausgewählte Grossräte über die Aufschaltung,
          eine Änderung oder sonstige Ereignisse informieren.
          Die ausgewählten Personen erhalten eine E-Mail mit Betreff und Nachricht.
        </p>
        <UsersTable v-model="value.users" :users="users" />
        <v-text-field
          v-model="value.title"
          :rules="[$rules.required]"
          label="Betreff"
          class="mt-4"
          box
        />
        <v-textarea
          v-model="value.message"
          :rules="[$rules.required]"
          label="Nachricht"
          rows=10
          auto-grow
          box
        />
      </v-card-text>
      <v-card-actions>
        <v-btn
          :disabled="!valid || !value.users.length"
          type="submit"
          color="primary"
          depressed
        >
          {{ submitText }}
        </v-btn>
        <v-btn
          @click="cancel"
          depressed
        >Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import User from '@/models/user';

export default {
  name: 'SendNotificationForm',
  props: {
    value: {
      type: Object,
      required: true,
    },
    submitText: {
      type: String,
      default: () => 'senden',
    },
  },
  data() {
    return {
      valid: false,
    };
  },
  created() {
    User.fetchAll();
  },
  computed: {
    users() {
      return User.all();
    },
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$emit('submit');
      }
    },
    cancel() {
      this.$emit('cancel');
      this.$refs.form.reset();
    },
  },
};
</script>
